module.exports = __webpack_public_path__ + "static/img/proximanova-light-webfont.913d744.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/proximanova-light-webfont.svg
// module id = 8NvL
// module chunks = 1